// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import ReactPanelBaseView from 'toolbar/ReactPanelBaseView';

const EntryHistoryPanel = require('notebook/entries/backbone/panels/EntryHistoryPanel').default;

class EntryHistoryPanelView extends ReactPanelBaseView {
  getSubpanels() {
    return [
      {
        key: 'history',
        title: 'History',
        component: (
          <EntryHistoryPanel
            id={this.model.id}
            folderId={this.model.folder().api_identifier}
            name={this.model.name()}
            permissions={this.model.permissions()}
          />
        ),
      },
    ];
  }
}

export default EntryHistoryPanelView;
